var Trigger = {
    init: function () {
        var $triggers = $(document).find('[data-trigger], [data-trigger]:checkbox');

        var cb = function ($this) {
            var checked = $this.is(':checked'),
                selector = $this.attr('data-trigger'),
                $targets = $(selector);

            $targets.each(function () {
                var $wrapper = $(this).closest('[data-trigger-wrapper]');

                if (checked) {
                    $(this).attr('required', true);
                    $wrapper.removeClass('hidden');
                } else {
                    $(this).attr('required', null);
                    $wrapper.addClass('hidden');
                }
            });
        };

        $triggers.each(function () {
            $(this).on('change', function () { cb($(this)); });
            cb($(this));
        });
    }
};

$(document).ready(function () {
    Trigger.init();
});
